module.exports = __webpack_public_path__ + "assets/img/w-c-10.cdd60098.png";